import Vue from 'vue';
import moment from 'lib/moment';
import 'lib/moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.filter('uppercase', function (value) {
  if (!value) {
    return '';
  }

  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
var defaultNum = 2;
Vue.filter('toFixed', function (value) {
  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultNum;

  if (!value) {
    return value;
  }

  return Number(value).toFixed(num);
});
Vue.filter('dateFormat', function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  return moment(value).format(format);
});
Vue.filter('fromNow', function (value) {
  return moment(value).fromNow();
});